export default __webpack_public_path__ + "img/icon_pro-3991f52b833bb14beed3a6d6271eb2c1.png";